<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent @change="onYearSelected" />
      </el-col>
      <el-col :span="3">
        <DirectionSelector
          @selection-change="updateSelectedDirection"
          @directionData="DirectionData"
        />
      </el-col>
      <el-col :span="3">
        <EmployeeSelector
          :placeholder="'Responsable'"
          :DireccionParams="selectedDirection"
          @selection-change="updateSelectedEmployee"
          @list-employee="employeList = $event"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";
import DirectionSelector from "@/components/Company/DirectionSelector";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";

export default {
  name: "InternalRequestByModuleReportFilter",
  components: {
    YearsComponent,
    DirectionSelector,
    EmployeeSelector
  },
  data() {
    return {
      selectedDirection: ""
    };
  },

  mounted() {},

  methods: {
    onYearSelected(year) {
      this.$emit("onYearSelected", year);
    },
    updateSelectedDirection(direction) {
      this.selectedDirection = direction;
      this.$emit("OnDirectionSelected", direction);
    },
    updateSelectedEmployee(employ) {
      this.$emit("EmployeeSelected", employ);
    }
  }
};
</script>

<style scoped></style>
